import React, { FC, useState } from 'react'
import { CaretLeftIcon } from '@/atoms/Icons/CaretLeftIcon'
import { CaretRightIcon } from '@/atoms/Icons/CaretRightIcon'

interface HomesteadLightBoxProps {
  showImages: { src: string; alt: string }[]
  currentImageIndex: number
  setIsLightboxOpen: (isOpen: boolean) => void
  setCurrentImageIndex: (index: number) => void
}

export const HomesteadLightBox: FC<HomesteadLightBoxProps> = ({
  showImages,
  currentImageIndex,
  setIsLightboxOpen,
  setCurrentImageIndex,
}) => {
  const [touchStart, setTouchStart] = useState<number | null>(null)
  const [touchEnd, setTouchEnd] = useState<number | null>(null)

  const closeLightbox = () => {
    setIsLightboxOpen(false)
  }

  const handleBackgroundClick = () => {
    closeLightbox()
  }

  const handleContentClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation()
  }

  const goToPrevious = () => {
    const newIndex = currentImageIndex === 0 ? showImages.length - 1 : currentImageIndex - 1
    setCurrentImageIndex(newIndex)
  }

  const goToNext = () => {
    const newIndex = currentImageIndex === showImages.length - 1 ? 0 : currentImageIndex + 1
    setCurrentImageIndex(newIndex)
  }

  const handleTouchStart = (e: React.TouchEvent) => {
    setTouchStart(e.targetTouches[0]?.clientX ?? null)
  }

  const handleTouchMove = (e: React.TouchEvent) => {
    setTouchEnd(e.targetTouches[0]?.clientX ?? null)
  }

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return
    const swipeDistance = touchStart - touchEnd
    const swipeThreshold = 50

    if (swipeDistance > swipeThreshold) {
      goToNext()
    }

    if (swipeDistance < -swipeThreshold) {
      goToPrevious()
    }

    setTouchStart(null)
    setTouchEnd(null)
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/75"
      id="lightbox-background"
      onClick={handleBackgroundClick}
    >
      <div
        className="relative"
        onClick={handleContentClick}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        <button className="absolute left-1 top-1/2 -translate-y-1/2 text-3xl lg:-left-7" onClick={goToPrevious}>
          <CaretLeftIcon size={24} />
        </button>

        <button className="absolute right-1 top-1/2 -translate-y-1/2 text-3xl lg:-right-7" onClick={goToNext}>
          <CaretRightIcon size={24} />
        </button>

        <img
          src={showImages[currentImageIndex]?.src}
          alt={showImages[currentImageIndex]?.alt}
          className="max-h-screen max-w-full rounded-lg shadow-lg lg:max-w-screen-lg"
        />
      </div>
    </div>
  )
}
